<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :btnRefreshVisible="true" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Progetto:</label>
                        <b-form-select v-model="filtroProgettoPri.nomeProgetto" type="search" id="tipoScale" placeholder="Inserire tipo scala" :options="tipoProgettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Progetto - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <!--<b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="filtroProgettoPri.dataDal" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="filtroProgettoPri.dataAl" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>-->
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-paziente-progetto-pri-list-component ref="cmpRsaPazienteProgettoPriList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-paziente-progetto-pri-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteProgettoPriListComponent from "../components/RsaPazienteProgettoPriListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        utente: { type: Object },
    },
    components: { SaPageLayout, RsaOspiteAnagraficaComponent, RsaPazienteProgettoPriListComponent },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtroProgettoPri: { nomeProgetto: null },
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            pathResourceSchedeValutazione: "/rsaschedevalutazione",
            showModalLoading: false,
            listKey: 0,
            tipoProgettoOptions: [],
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroProgettoPri"]) {
            me.filtroProgettoPri = JSON.parse(sessionStorage["filtroProgettoPri"]);
        }
        me.loadAccettazione();
        me.loadProgettiOptions();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            //   me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaPazienteProgettoPriList.init(me.idAccettazione);
                    //  me.showModalLoading = false;
                })
                .catch((err) => {
                    console.log(err);
                    // me.showModalLoading = false;
                });
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onRefresh() {
            let me = this;
            me.loadAccettazione();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroProgettoPri"] = JSON.stringify(me.filtroProgettoPri);
            me.loadAccettazione();
        },
        onReset() {
            let me = this;
            me.filtroProgettoPri = { nomeProgetto: null, idAccettazione: me.idAccettazione };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroProgettoPri"] = JSON.stringify(me.filtroProgettoPri);
            me.loadAccettazione();
        },
        loadProgettiOptions() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedeValutazione, { sezione: "PRI" }, me.resultResponseProgetti, me.resultErrorProgetti);
        },
        resultResponseProgetti(response) {
            let me = this;
            response.data.data.list.forEach((element) => {
                me.tipoProgettoOptions.push({ text: element.tipoScheda, value: element.tipoScheda });
            });
        },
        resultErrorProgetti(error) {
            console.log(error.response.data.messagio);
        },
    },
};
</script>

<style></style>
